import { Check, Info } from 'lucide-react';
import { Box } from './box';

// Emerald/Toast (1666:20631): the AppModal surface lifted onto the screen.
// Shared by the Chakra toaster (toaster.tsx) and the update / offline notice
// (UpdateNotification.tsx), which has its own two-button layout.
export const TOAST_SURFACE = {
  w: 'min(358px, calc(100vw - 2rem))',
  bg: 'spades.surface',
  backgroundImage: 'var(--spades-panel-gradient)',
  border: '1.5px solid',
  borderColor: 'var(--spades-border-strong)',
  borderRadius: 'var(--spades-radius-lg)',
  boxShadow:
    '0 16px 20px rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
  color: 'var(--spades-ivory)',
} as const;

/** Success wears the felt badge with a mint ring, everything else the dark
 *  badge with a maple ring. */
export const ToastIconBadge = ({ success }: { success: boolean }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
    w="36px"
    h="36px"
    borderRadius="var(--spades-radius-pill)"
    border="1.5px solid"
    bg={success ? 'var(--spades-felt-dark)' : 'var(--spades-background)'}
    borderColor={success ? 'var(--spades-mint)' : 'var(--spades-accent-base)'}
    color="var(--spades-ivory)"
  >
    {success ? <Check size={18} /> : <Info size={18} />}
  </Box>
);
